import React, {useEffect, useState} from 'react';
import {
  Button,
  Card, CardActions, CardContent,
  CardHeader,
  Divider,
  Modal,
  TextField
} from '@material-ui/core';
import axios from 'axios';
import {Autocomplete} from "@material-ui/lab";
import {toTitleCase} from "../../../../helpers/utils";

const MigrateModal = ({open, onClose, handleMigrate, adminUserSession, investors}) => {
  const [groups, setGroups] = useState([])
  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [selectedInvestor, setSelectedInvestor] = useState({})
  const [showWhat, setShowWhat] = useState('none')

  useEffect(() => {
    const firstItem = investors[0];
    setSelectedInvestor(firstItem)
    handleFetchGroups(firstItem.id)
  }, [])

  const handleFetchGroups = (crdId) => {
    axios.get(
        `/v1/admin/ria_investors/${crdId}/private_wealth_teams`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': adminUserSession.email,
            'X-Admin-User-Token': adminUserSession.token
          }
        }
    ).then((response) => {
      const {
        teams,
      } = response.data
      setGroups(teams)
      setShowWhat(teams.length > 0 ? 'groups' : 'placeholder')
    })
  }

  const handleOnChange = (value) => {
    if (value) {
      setSelectedInvestor(value)
      handleFetchGroups(value.id)
    } else {
      setSelectedInvestor({id: null, name: ''})
      setSelectedGroupId(null)
      setGroups([])
      setShowWhat('none')
    }
  }

  const renderGroups = () => {
    if (showWhat === 'groups') {
      return <Autocomplete
          options={groups}
          handleOnChange={(value) => value ? console.log({value}) : null}
          onChange={(event, value) => value ? setSelectedGroupId(value.id) : setSelectedGroupId(null)}
          getOptionSelected={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${toTitleCase(option.team_name)} (${option.stage})`}
          renderInput={(params) => (
              <TextField
                  {...params}
                  label="Group"
                  variant="outlined"
              />
          )}
          disabled={!selectedInvestor}
      />
    } else if (showWhat === 'placeholder') {
      return <span>FIRM DOESN'T HAVE GROUPS</span>
    } else {
      return <></>
    }
  }


  return (
      <Modal open={open} onClose={onClose}>
        <Card style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          maxHeight: '100%',
          overflowY: 'auto',
          width: '20%',
        }}>
          <CardHeader title={'Select group'}/>
          <CardContent style={{display: 'flex', flexDirection: 'column'}}>
            <Autocomplete
                options={investors}
                handleOnChange={(value) => value ? console.log({value}) : null}
                onChange={(event, value) => handleOnChange(value)}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name ? toTitleCase(option.name) : ''}
                defaultValue={investors[0]}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Parent Company"
                        variant="outlined"
                    />
                )}
            />
            <div style={{marginTop: '20px'}}>{renderGroups()}</div>
          </CardContent>
          <Divider/>
          <CardActions style={{justifyContent: 'flex-end'}}>
            <Button onClick={onClose}>CANCEL</Button>
            <Button
              onClick={() => handleMigrate(selectedGroupId)}
              disabled={!selectedInvestor?.id || !selectedGroupId}
            >
              MIGRATE
            </Button>
          </CardActions>
        </Card>
      </Modal>
  )
}

export default MigrateModal;